import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d6c29ee4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-row space-x-2 items-center justify-start" };
const _hoisted_2 = { class: "text-md font-normal text-gray-900" };
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    class: "flex flex-wrap px-2",
    style: { "column-gap": "7px", "row-gap": "10px" }
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "p-0.5 flex flex-col items-center rounded-lg border-gray-100 border" };
const _hoisted_7 = ["id", "src"];
const _hoisted_8 = { class: "text-xs font-normal text-gray-700 text-center" };
import { ChevronRightIcon } from '@gohighlevel/ghl-icons/24/outline';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UICollapse',
    props: {
        canvasCtx: {
            type: Object,
            require: true,
        },
        title: {
            type: String,
            require: true,
        },
        options: {
            type: Array,
        },
        url: {
            type: String,
        },
        filterImage: {
            type: Object,
        },
        selectedOption: {
            type: String,
        },
        defaultPreviewImage: {
            type: String,
        },
    },
    emits: ['setFilters'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const open = ref(false);
        function setFilters(filterData) {
            emits('setFilters', filterData);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["w-[232px] h-auto border rounded-lg flex flex-col space-y-2", open.value ? 'border-primary' : 'border-gray-300'])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["w-full flex flex-row items-center justify-between py-2 px-2 h-20 cursor-pointer rounded-t-lg hl_collapse-bg", open.value ? 'bg-primary-50 border-b border-gray-300' : '']),
                    onClick: _cache[0] || (_cache[0] = ($event) => (open.value = !open.value))
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(ChevronRightIcon), {
                            class: _normalizeClass(["w-5 h-5 text-gray-900 hl_collapse-icon", open.value ? 'hl_open-collapse' : ''])
                        }, null, 8, ["class"]),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(__props.title)), 1)
                    ]),
                    _createElementVNode("img", {
                        src: __props.url,
                        class: "w-16 h-16 rounded-lg"
                    }, null, 8, _hoisted_3)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["flex flex-col hl_collapse-content overflow-hidden", open.value ? 'hl_collapse-maxheight py-2' : ''])
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: option.title,
                                style: { "height": "106px", "width": "71.33px" },
                                class: _normalizeClass(["flex flex-col items-center space-y-2 cursor-pointer rounded-md", __props.selectedOption == option.value ? 'border border-primary' : '']),
                                onClick: ($event) => (setFilters(option))
                            }, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("img", {
                                        id: option.value,
                                        src: option.url,
                                        class: "w-16 h-16 rounded-lg"
                                    }, null, 8, _hoisted_7)
                                ]),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(option.title)), 1)
                            ], 10, _hoisted_5));
                        }), 128))
                    ])
                ], 2)
            ], 2));
        };
    }
});
